import css from './menu.module.scss';

import usePosition from './usePosition';

type TProps = {
  children: React.ReactNode;
  anchorNode: SVGElement | HTMLElement;
  close: () => void;
};

const MenuPopup = ({ anchorNode, children, close }: TProps) => {
  const { pos, setPopup } = usePosition(anchorNode, close);

  return (
    <div className={css.menuOverlay}>
      <div className={css.menuPopup} style={pos} ref={setPopup}>
        {children}
      </div>
    </div>
  );
};

export default MenuPopup;
